import { render, staticRenderFns } from "./onSubFormRowAdd-editor.vue?vue&type=template&id=08b0e823&scoped=true"
import script from "./onSubFormRowAdd-editor.vue?vue&type=script&lang=js"
export * from "./onSubFormRowAdd-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0e823",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b0e823')) {
      api.createRecord('08b0e823', component.options)
    } else {
      api.reload('08b0e823', component.options)
    }
    module.hot.accept("./onSubFormRowAdd-editor.vue?vue&type=template&id=08b0e823&scoped=true", function () {
      api.rerender('08b0e823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onSubFormRowAdd-editor.vue"
export default component.exports